var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 701 289",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fae757;\n      }\n\n      .cls-2 {\n        fill: #fcdbbc;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23 {\n        fill: none;\n      }\n\n      .cls-3, .cls-4, .cls-6, .cls-9, .cls-10, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-18, .cls-19, .cls-20 {\n        stroke-linecap: round;\n      }\n\n      .cls-3, .cls-4, .cls-6, .cls-10, .cls-12, .cls-13, .cls-18, .cls-19, .cls-20 {\n        stroke-linejoin: round;\n      }\n\n      .cls-3, .cls-4, .cls-6, .cls-15, .cls-16, .cls-23 {\n        stroke: #000;\n      }\n\n      .cls-3, .cls-16 {\n        stroke-width: 2.78px;\n      }\n\n      .cls-4 {\n        stroke-width: 3.4px;\n      }\n\n      .cls-24 {\n        fill: #825c41;\n      }\n\n      .cls-25 {\n        fill: #3b271b;\n      }\n\n      .cls-26 {\n        fill: #4d3423;\n      }\n\n      .cls-5, .cls-7, .cls-8, .cls-9, .cls-11, .cls-14, .cls-15, .cls-16, .cls-17, .cls-21, .cls-22, .cls-23 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-5, .cls-7, .cls-14, .cls-17, .cls-19, .cls-21 {\n        stroke-width: 2px;\n      }\n\n      .cls-5, .cls-14, .cls-18, .cls-19 {\n        stroke: #000d19;\n      }\n\n      .cls-6, .cls-11, .cls-13, .cls-15, .cls-23 {\n        stroke-width: 3px;\n      }\n\n      .cls-7 {\n        stroke: #42c763;\n      }\n\n      .cls-27 {\n        fill: #015e59;\n      }\n\n      .cls-28 {\n        fill: #faf9f8;\n      }\n\n      .cls-29 {\n        fill: #6e2f22;\n      }\n\n      .cls-30 {\n        fill: #f8d9bc;\n      }\n\n      .cls-31 {\n        fill: #cc8f70;\n      }\n\n      .cls-8 {\n        stroke: #fff;\n      }\n\n      .cls-32 {\n        fill: #f4b497;\n      }\n\n      .cls-33 {\n        fill: #66452e;\n      }\n\n      .cls-34 {\n        fill: #260809;\n      }\n\n      .cls-35 {\n        fill: #7150b3;\n      }\n\n      .cls-36 {\n        opacity: .5;\n      }\n\n      .cls-36, .cls-37 {\n        fill: #fff;\n      }\n\n      .cls-38 {\n        fill: #4d65b4;\n      }\n\n      .cls-39 {\n        fill: #4d1417;\n      }\n\n      .cls-40 {\n        fill: #eeb68c;\n      }\n\n      .cls-41 {\n        fill: #373db0;\n      }\n\n      .cls-42 {\n        fill: #b7c8d8;\n      }\n\n      .cls-43 {\n        fill: #ee927e;\n      }\n\n      .cls-44 {\n        fill: #f6c09c;\n      }\n\n      .cls-45 {\n        fill: #bfa776;\n      }\n\n      .cls-46 {\n        fill: #063842;\n      }\n\n      .cls-9 {\n        stroke: #f5c13d;\n        stroke-width: 3.11px;\n      }\n\n      .cls-47 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-48 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-49 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-50 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-51 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-52 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-53 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-54 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-55 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-56 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-57 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-58 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-59 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-60 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-61 {\n        fill: #e6eef2;\n      }\n\n      .cls-62 {\n        fill: #7bd2e8;\n      }\n\n      .cls-10 {\n        stroke: #033040;\n        stroke-width: 24.93px;\n      }\n\n      .cls-63 {\n        fill: #cfb580;\n      }\n\n      .cls-11 {\n        stroke: #507e8f;\n      }\n\n      .cls-64 {\n        fill: #8cbab7;\n      }\n\n      .cls-65 {\n        fill: #ffd24a;\n      }\n\n      .cls-66 {\n        fill: #42c763;\n      }\n\n      .cls-67 {\n        fill: #b192f3;\n      }\n\n      .cls-68 {\n        fill: #8c432b;\n      }\n\n      .cls-69 {\n        fill: #1b526d;\n      }\n\n      .cls-70 {\n        fill: #eb175a;\n      }\n\n      .cls-71 {\n        fill: #eb986d;\n      }\n\n      .cls-12 {\n        stroke-width: 3.17px;\n      }\n\n      .cls-12, .cls-13, .cls-20 {\n        stroke: #eeb68c;\n      }\n\n      .cls-72 {\n        fill: #edb58c;\n      }\n\n      .cls-73 {\n        fill: #000d19;\n      }\n\n      .cls-74 {\n        fill: #f8c79d;\n      }\n\n      .cls-75 {\n        fill: #0d5359;\n      }\n\n      .cls-76 {\n        fill: #4d9be6;\n      }\n\n      .cls-77 {\n        fill: #63e06b;\n      }\n\n      .cls-78 {\n        fill: #8ff584;\n      }\n\n      .cls-79 {\n        fill: #073f4a;\n      }\n\n      .cls-80 {\n        fill: #ffae4a;\n      }\n\n      .cls-81 {\n        fill: #556ec9;\n      }\n\n      .cls-82 {\n        fill: #8f005d;\n      }\n\n      .cls-83 {\n        fill: #052b33;\n      }\n\n      .cls-84 {\n        fill: #6fe8dd;\n      }\n\n      .cls-85 {\n        fill: #360b0e;\n      }\n\n      .cls-17 {\n        stroke: #4eadad;\n      }\n\n      .cls-86 {\n        fill: #fa98be;\n      }\n\n      .cls-18 {\n        stroke-width: 2.27px;\n      }\n\n      .cls-87 {\n        fill: #65442e;\n      }\n\n      .cls-20 {\n        stroke-width: 2.32px;\n      }\n\n      .cls-21 {\n        stroke: #d99037;\n      }\n\n      .cls-88 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-89 {\n        fill: #002131;\n      }\n\n      .cls-22 {\n        stroke: #906ed9;\n        stroke-width: 7px;\n      }\n\n      .cls-90 {\n        fill: #154259;\n      }\n\n      .cls-91 {\n        fill: #033040;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 500.18,
    y: 99.24,
    width: 24.31,
    height: 34.06,
    rx: 10.52,
    ry: 10.52,
    transform: "translate(1034.5 174.27) rotate(173.55)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 454.67,
    y: 104.38,
    width: 24.31,
    height: 34.06,
    rx: 10.52,
    ry: 10.52,
    transform: "translate(944.34 189.63) rotate(173.55)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M412.45,154.86l1.12-1.12c.69-.69,1.82-.69,2.52,0l2.88,2.88,23.15,23.15c.58.58,1.03,1.29,1.3,2.06l2.5,7.11-4.07,4.07-2.47-2.47-24.16-24.16-3.26-9.27c-.28-.78-.08-1.66.51-2.25Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "414.4 164.09 417.74 160.75 421.87 164.88 445.91 188.91 458.83 225.76 455.49 229.1 453.01 226.62 427.32 200.93 414.4 164.09"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "455.47 220.56 444.01 188.34 421.06 165.39 432.52 197.61 455.47 220.56"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M427.32,200.93l3.34-3.34,4.13,4.13,24.03,24.03,1.61,4.54c.46,1.3.13,2.75-.84,3.73h0c-1.37,1.37-3.58,1.37-4.95,0h0s-22.1-22.1-22.1-22.1c-1.36-1.36-2.39-3-3.03-4.81l-2.19-6.19Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M592.66,203.26h44.18c3.88,0,7.02,3.15,7.02,7.02v8.09c0,7.19-5.83,13.02-13.02,13.02h-32.18c-7.19,0-13.02-5.83-13.02-13.02v-8.09c0-3.88,3.15-7.02,7.02-7.02Z",
    transform: "translate(1229.49 434.65) rotate(-180)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M564.11,160.21h22.6c4.67,0,7.39-5.26,4.7-9.08l-1.65-2.33c-7-9.91-21.7-9.91-28.7,0l-1.65,2.33c-2.69,3.81.03,9.08,4.7,9.08Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M630.62,160.21h-22.6c-4.67,0-7.39-5.26-4.7-9.08l1.65-2.33c7-9.91,21.7-9.91,28.7,0l1.65,2.33c2.69,3.81-.03,9.08-4.7,9.08Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M279.2,59.96h45.96c10.79,0,19.55,8.76,19.55,19.55v64.08c0,16.83-13.67,30.5-30.5,30.5h-24.07c-16.83,0-30.5-13.67-30.5-30.5v-64.08c0-10.79,8.76-19.55,19.55-19.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M165.3,192.93h23.67c9.59,0,17.37,7.78,17.37,17.37v9.29c0,3.49-2.83,6.32-6.32,6.32h-45.77c-3.49,0-6.32-2.83-6.32-6.32v-9.29c0-9.59,7.78-17.37,17.37-17.37Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 168.23,
    y: 130.54,
    width: 24.13,
    height: 33.8,
    rx: 10.44,
    ry: 10.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 207.48,
    y: 130.54,
    width: 24.13,
    height: 33.8,
    rx: 10.44,
    ry: 10.44
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M80.59,101.71h-21.79c-4.5,0-7.13,5.07-4.53,8.75l1.59,2.25c6.75,9.55,20.91,9.55,27.67,0l1.59-2.25c2.6-3.67-.03-8.75-4.53-8.75Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M125.84,101.71h-21.79c-4.5,0-7.13,5.07-4.53,8.75l1.59,2.25c6.75,9.55,20.91,9.55,27.67,0l1.59-2.25c2.6-3.67-.03-8.75-4.53-8.75Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 552.94,
    cy: 49.62,
    r: 12.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 537.22,
    cy: 41.9,
    r: 12.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 564.91,
    cy: 59.16,
    r: 12.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 574.45,
    cy: 70.59,
    r: 12.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 582.88,
    cy: 82.92,
    r: 12.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 587.15,
    cy: 97.92,
    r: 12.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 590.07,
    cy: 113.23,
    r: 12.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 591.77,
    cy: 128.24,
    r: 12.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 591.62,
    cy: 141.88,
    r: 12.43
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 452.63,
    cy: 60.96,
    r: 12.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 466.23,
    cy: 49.92,
    r: 12.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 443.09,
    cy: 72.92,
    r: 12.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 436.34,
    cy: 86.2,
    r: 12.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 430.87,
    cy: 100.1,
    r: 12.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 430.06,
    cy: 115.67,
    r: 12.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 430.63,
    cy: 131.25,
    r: 12.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 432.33,
    cy: 146.26,
    r: 12.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 435.51,
    cy: 159.52,
    r: 12.43
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M445.38,31.24h127.06c12.21,0,22.12,9.91,22.12,22.12v37.13c0,40.91-33.21,74.12-74.12,74.12h-23.07c-40.91,0-74.12-33.21-74.12-74.12v-37.13c0-12.21,9.91-22.12,22.12-22.12Z",
    transform: "translate(1025.59 138.1) rotate(173.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M496.55,356.15c8.3,0,15.02-6.73,15.02-15.02v-51.93c0-8.3-6.73-15.02-15.02-15.02s-15.02,6.73-15.02,15.02v51.93c0,8.3,6.73,15.02,15.02,15.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M476.16,342.03h37.53v16.96c0,2.41-1.95,4.36-4.36,4.36h-39.47c-2.77,0-5.02-2.25-5.02-5.02v-4.98c0-6.25,5.07-11.32,11.32-11.32Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 426,
    y: 170.69,
    width: 20.31,
    height: 16.15,
    transform: "translate(849.83 -47.21) rotate(129.07)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M462.17,218.28c-6.12-4.97-7.06-13.96-2.09-20.09l20.93-25.78c4.97-6.12,13.96-7.06,20.09-2.09,6.12,4.97,7.06,13.96,2.09,20.09l-20.93,25.78c-4.97,6.12-13.96,7.06-20.09,2.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M461.86,218.02l-27.3-22.16c-1.61-1.31-1.86-3.67-.55-5.28l13.27-16.34c1.31-1.61,3.67-1.86,5.28-.55l27.62,22.42c6.3,5.11,7.11,14.5,1.64,20.62-5.12,5.73-13.98,6.15-19.95,1.3Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-68",
    cx: 433.66,
    cy: 169.02,
    r: 16.15
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 479.4,
    y: 328.07,
    width: 34.29,
    height: 25.96,
    transform: "translate(993.09 682.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M526.59,319.84c8.3,0,15.02-6.73,15.02-15.02v-51.93c0-8.3-6.73-15.02-15.02-15.02s-15.02,6.73-15.02,15.02v51.93c0,8.3,6.73,15.02,15.02,15.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M526.59,371.76c8.3,0,15.02-6.73,15.02-15.02v-51.93c0-8.3-6.73-15.02-15.02-15.02s-15.02,6.73-15.02,15.02v51.93c0,8.3,6.73,15.02,15.02,15.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M496.55,304.22c8.3,0,15.02-6.73,15.02-15.02v-36.95c0-8.3-6.73-15.02-15.02-15.02s-15.02,6.73-15.02,15.02v36.95c0,8.3,6.73,15.02,15.02,15.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M481.52,228.8h60.09v12.43c0,10.72-8.71,19.43-19.43,19.43h-21.23c-10.72,0-19.43-8.71-19.43-19.43v-12.43h0Z",
    transform: "translate(1023.13 489.47) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M503.85,241.3h.67c2.36,0,4.27,1.92,4.27,4.27v11.66h-4.94v-15.93h0Z",
    transform: "translate(1012.63 498.54) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M490.72,175.45h46.57c4.6,0,8.33,3.73,8.33,8.33v38.99c0,6.96-5.65,12.61-12.61,12.61h-38.02c-6.96,0-12.61-5.65-12.61-12.61v-38.99c0-4.6,3.73-8.33,8.33-8.33Z",
    transform: "translate(1028.01 410.83) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 500.61,
    y: 159.3,
    width: 26.26,
    height: 19.33,
    transform: "translate(1027.49 337.92) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M492.14,168.59h43.73v8.1c0,2.42-1.96,4.38-4.38,4.38h-34.97c-2.42,0-4.38-1.96-4.38-4.38v-8.1h0Z",
    transform: "translate(1028.01 349.65) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M506.21,357.65h37.53v16.96c0,2.41-1.95,4.36-4.36,4.36h-39.47c-2.77,0-5.02-2.25-5.02-5.02v-4.98c0-6.25,5.07-11.32,11.32-11.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 509.45,
    y: 343.68,
    width: 34.29,
    height: 25.96
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-68",
    cx: 449.16,
    cy: 123.65,
    r: 16.85
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-68",
    cx: 553.03,
    cy: 111.92,
    r: 16.85
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M455.76,26.44h93.47c5.89,0,10.67,4.78,10.67,10.67v36.8c0,23.73-19.27,43-43,43h-28.81c-23.73,0-43-19.27-43-43v-36.8c0-5.89,4.78-10.67,10.67-10.67Z",
    transform: "translate(1009.86 86.48) rotate(173.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M448.99,133.7c-7.3.82-12.54,7.41-11.72,14.7s7.41,12.54,14.7,11.72,12.54-7.41,11.72-14.7c-.36-3.22-1.85-6.04-4.02-8.12"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M554.15,121.81c7.3-.82,13.88,4.42,14.7,11.72s-4.42,13.88-11.72,14.7-13.88-4.42-14.7-11.72c-.36-3.22.46-6.3,2.11-8.81"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M492.91,69.53h16.59c21.74,0,39.39,17.65,39.39,39.39v37.08c0,15.65-12.71,28.36-28.36,28.36h-38.64c-15.65,0-28.36-12.71-28.36-28.36v-37.08c0-21.74,17.65-39.39,39.39-39.39Z",
    transform: "translate(1012.93 186.85) rotate(173.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M484.12,152.69c-2.06.23-3.2,2.6-2.01,4.3,3.41,4.87,9.31,7.77,15.64,7.05s11.45-4.86,13.68-10.37c.78-1.92-.85-3.98-2.92-3.74l-24.4,2.76Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 500.18,
    y: 99.24,
    width: 24.31,
    height: 34.06,
    rx: 10.52,
    ry: 10.52,
    transform: "translate(1034.5 174.27) rotate(173.55)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 502.4,
    y: 112.06,
    width: 13.51,
    height: 22.67,
    rx: 5.85,
    ry: 5.85,
    transform: "translate(1028.95 188.84) rotate(173.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 508.62,
    y: 108.08,
    width: 7.39,
    height: 13.48,
    rx: 3.2,
    ry: 3.2,
    transform: "translate(1034.28 171.37) rotate(173.55)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M523.91,110.44l-.02-.21c-.75-6.67-6.77-11.47-13.44-10.71h0c-6.67.75-11.47,6.77-10.71,13.44l.02.21"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 527.47,
    y1: 105.8,
    x2: 523.36,
    y2: 107.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 525.32,
    y1: 101.4,
    x2: 521.55,
    y2: 103.99
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M523.06,124.08h14.19v4.68c0,7.19-5.83,13.02-13.02,13.02h-2.8c-2.75,0-4.98-2.23-4.98-4.98v-6.12c0-3.65,2.96-6.61,6.61-6.61Z",
    transform: "translate(1065.3 205.86) rotate(173.55)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 454.67,
    y: 104.38,
    width: 24.31,
    height: 34.06,
    rx: 10.52,
    ry: 10.52,
    transform: "translate(944.34 189.63) rotate(173.55)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 458.04,
    y: 117.4,
    width: 13.51,
    height: 22.67,
    rx: 5.85,
    ry: 5.85,
    transform: "translate(941.11 204.46) rotate(173.55)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 464.26,
    y: 113.41,
    width: 7.39,
    height: 13.48,
    rx: 3.2,
    ry: 3.2,
    transform: "translate(946.44 187) rotate(173.55)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M454.25,118.32l-.02-.21c-.75-6.67,4.04-12.69,10.71-13.44h0c6.67-.75,12.69,4.04,13.44,10.71l.02.21"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 449.74,
    y1: 114.59,
    x2: 454.2,
    y2: 115.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 450.85,
    y1: 109.81,
    x2: 455.11,
    y2: 111.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M453.24,131.65h1.79c6.35,0,11.51,5.16,11.51,11.51v6.19h-9.45c-2.13,0-3.86-1.73-3.86-3.86v-13.84h0Z",
    transform: "translate(-12.87 52.53) rotate(-6.45)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M460.72,112.72h8.74c7.93,0,14.37,6.44,14.37,14.37v7.37c0,4.11-3.33,7.44-7.44,7.44h-22.6c-4.11,0-7.44-3.33-7.44-7.44v-7.37c0-7.93,6.44-14.37,14.37-14.37Z",
    transform: "translate(941.54 201.59) rotate(173.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M509.97,107.15h8.74c7.93,0,14.37,6.44,14.37,14.37v7.37c0,4.11-3.33,7.44-7.44,7.44h-22.6c-4.11,0-7.44-3.33-7.44-7.44v-7.37c0-7.93,6.44-14.37,14.37-14.37Z",
    transform: "translate(1039.11 184.96) rotate(173.55)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M495.32,120.25s-1.89-3.07-6.37-2.56c-4.94.56-5.61,4.18-5.61,4.18"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M489.56,123.1l2.19,19.41c.32,2.79-1.69,5.32-4.49,5.63l-3.07.35c-3.82.43-6.75-3.32-5.4-6.93l7.08-18.92c.7-1.88,3.46-1.54,3.68.45Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M542.91,66.3h2.92c1.58,0,2.86,1.28,2.86,2.86v100.8h-2.92c-10.35,0-18.74-8.4-18.74-18.74v-69.04c0-8.77,7.12-15.88,15.88-15.88Z",
    transform: "translate(1085.58 175.11) rotate(173.55)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 519.38,
    cy: 77.52,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 519.55,
    cy: 71.77,
    r: 5.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 510.88,
    cy: 70.41,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 499.03,
    cy: 66.11,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 525.38,
    cy: 88.34,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 526.69,
    cy: 99.9,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 527.88,
    cy: 110.42,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 531.45,
    cy: 142,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 532.64,
    cy: 152.52,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 533.82,
    cy: 163.05,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 529.07,
    cy: 120.95,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 530.26,
    cy: 131.47,
    r: 7.65
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M452.92,76.79h2.92v100.8c0,1.58-1.28,2.86-2.86,2.86h-2.92c-8.77,0-15.88-7.12-15.88-15.88v-69.04c0-10.35,8.4-18.74,18.74-18.74Z",
    transform: "translate(-11.63 50.78) rotate(-6.45)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 452.14,
    cy: 85.12,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 458.84,
    cy: 76.29,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 469.43,
    cy: 69.45,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 448.71,
    cy: 97.01,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 450.01,
    cy: 108.56,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 451.2,
    cy: 119.09,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 454.77,
    cy: 150.66,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 455.96,
    cy: 161.19,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 457.15,
    cy: 171.71,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 452.39,
    cy: 129.61,
    r: 7.65
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-73",
    cx: 453.58,
    cy: 140.14,
    r: 7.65
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-21",
    x1: 511.57,
    y1: 261.07,
    x2: 511.57,
    y2: 341.05
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M412.45,154.86l1.12-1.12c.69-.69,1.82-.69,2.52,0l2.88,2.88,23.15,23.15c.58.58,1.03,1.29,1.3,2.06l2.5,7.11-4.07,4.07-2.47-2.47-24.16-24.16-3.26-9.27c-.28-.78-.08-1.66.51-2.25Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M446.16,189.58l-2.83-8.6-27.85-27.85c-.16-.16-.42,0-.34.22l2.86,8.07,28.17,28.17Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "414.4 164.09 417.74 160.75 421.87 164.88 445.91 188.91 458.83 225.76 455.49 229.1 453.01 226.62 427.32 200.93 414.4 164.09"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-79",
    points: "458.83 225.76 448.07 191.07 417.74 160.75 430.66 197.59 458.83 225.76"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-62",
    points: "455.47 220.56 444.01 188.34 421.06 165.39 432.52 197.61 455.47 220.56"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-54"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "452.93 212.48 450.54 205.15 421.7 169.38 424.18 176.85 452.93 212.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "457.06 223.13 454.58 216.88 425.13 180.34 427.96 187 457.06 223.13"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M427.32,200.93l3.34-3.34,4.13,4.13,24.03,24.03,1.61,4.54c.46,1.3.13,2.75-.84,3.73h0c-1.37,1.37-3.58,1.37-4.95,0h0s-22.1-22.1-22.1-22.1c-1.36-1.36-2.39-3-3.03-4.81l-2.19-6.19Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M460.5,230.16l-1.34-4.06-28.5-28.5,1.94,5.49c.8,2.27,2.1,4.33,3.81,6.03l22.21,22.21c.85.85,2.26-.02,1.88-1.16Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-89",
    cx: 429.56,
    cy: 168.66,
    rx: 0.38,
    ry: 0.87,
    transform: "translate(-.62 335.73) rotate(-42.66)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-89",
    cx: 427.84,
    cy: 168.16,
    rx: 0.38,
    ry: 0.87,
    transform: "translate(-.74 334.44) rotate(-42.66)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-89",
    cx: 428.95,
    cy: 170.36,
    rx: 0.38,
    ry: 0.87,
    transform: "translate(-1.93 335.77) rotate(-42.66)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-89",
    cx: 430.58,
    cy: 170.76,
    rx: 0.38,
    ry: 0.87,
    transform: "translate(-1.78 336.98) rotate(-42.66)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-89",
    cx: 440.59,
    cy: 208.87,
    rx: 0.47,
    ry: 1.07,
    transform: "translate(-24.95 353.85) rotate(-42.66)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-89",
    cx: 438.48,
    cy: 208.3,
    rx: 0.47,
    ry: 1.07,
    transform: "translate(-25.12 352.26) rotate(-42.66)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-89",
    cx: 439.73,
    cy: 210.85,
    rx: 0.47,
    ry: 1.07,
    transform: "translate(-26.52 353.79) rotate(-42.66)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-89",
    cx: 441.83,
    cy: 211.48,
    rx: 0.47,
    ry: 1.07,
    transform: "translate(-26.39 355.38) rotate(-42.66)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-73",
    cx: 445.7,
    cy: 215.23,
    rx: 1.17,
    ry: 2.67,
    transform: "translate(-27.91 358.99) rotate(-42.66)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-89",
    cx: 446.48,
    cy: 214.45,
    rx: 1.17,
    ry: 2.67,
    transform: "translate(-27.17 359.32) rotate(-42.66)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    cx: 423.73,
    cy: 164.04,
    rx: 1.25,
    ry: 2.86,
    transform: "translate(.97 330.56) rotate(-42.66)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-89",
    cx: 424.67,
    cy: 163.1,
    rx: 1.25,
    ry: 2.86,
    transform: "translate(1.85 330.95) rotate(-42.66)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M430.4,207.05l1.99-1.9-1.91-5.8-.64-.41-1.9,1.9s1.26,3.86,1.51,4.68c.43,1.41.96,1.53.96,1.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M432.39,205.14l-1.91-5.8-.64-.41s1.27,3.85,1.51,4.68c.37,1.25,1.04,1.53,1.04,1.53Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M414.77,162.55l1.94-1.86-2.19-6.57-1.67,1.67c-.36.36-.49.9-.34,1.39l1.57,4.92.69.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M416.71,160.7l-2.19-6.57s-.44.29-.24.99c.12.42,1.69,5.06,1.69,5.06l.74.52Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-73",
    points: "414.77 162.56 416.71 160.7 415.96 160.18 414.07 162.11 414.77 162.56"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 452.45,
    y: 222.08,
    width: 20.31,
    height: 16.15,
    transform: "translate(232.45 692.77) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M497.63,240.02c5.58,5.58,14.62,5.58,20.2,0l23.48-23.48c5.58-5.58,5.58-14.62,0-20.2s-14.62-5.58-20.2,0l-23.48,23.48c-5.58,5.58-5.58,14.62,0,20.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M507.31,215.88h-35.17c-2.07,0-3.76,1.68-3.76,3.76v21.05c0,2.07,1.68,3.76,3.76,3.76h35.57c8.12,0,14.65-6.78,14.26-14.98-.36-7.68-6.98-13.59-14.67-13.59Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-68",
    cx: 454.95,
    cy: 224.17,
    r: 16.15
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M602.5,75.26h41.95c20.04,0,36.3,16.27,36.3,36.3v128.22c0,11.81-9.59,21.4-21.4,21.4h-56.1c-20.45,0-37.06-16.61-37.06-37.06v-112.57c0-20.04,16.27-36.3,36.3-36.3Z",
    transform: "translate(1246.94 336.45) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 583.87,
    y: 199.3,
    width: 20.02,
    height: 61.57,
    rx: 8.66,
    ry: 8.66
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 583.87,
    y: 240.82,
    width: 20.02,
    height: 61.57,
    rx: 8.66,
    ry: 8.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M603.89,293.12c0,9.15-7.42,16.58-16.58,16.58-9.15,0-16.58-7.42-16.58-16.58,0-9.15,7.42-16.58,16.58-16.58,9.15,0,16.58,7.42,16.58,16.58Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 594.86,
    y: 228.18,
    width: 39.78,
    height: 30.16,
    transform: "translate(1229.49 486.53) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M592.66,203.26h44.18c3.88,0,7.02,3.15,7.02,7.02v8.09c0,7.19-5.83,13.02-13.02,13.02h-32.18c-7.19,0-13.02-5.83-13.02-13.02v-8.09c0-3.88,3.15-7.02,7.02-7.02Z",
    transform: "translate(1229.49 434.65) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M601.56,203.26h20.41c4.73,0,8.57,3.84,8.57,8.57v8h-37.55v-8c0-4.73,3.84-8.57,8.57-8.57Z",
    transform: "translate(1223.52 423.09) rotate(-180)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M578.26,249.92h72.97v14.46c0,12.37-10.05,22.42-22.42,22.42h-28.13c-12.37,0-22.42-10.05-22.42-22.42v-14.46h0Z",
    transform: "translate(1229.49 536.73) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 594.86,
    y: 246.44,
    width: 39.78,
    height: 14.44,
    transform: "translate(1229.49 507.33) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M644.12,394.79l4.02-10.58c3.63-9.57-3.44-19.81-13.67-19.81h0c-10.23,0-17.3,10.24-13.67,19.81l4.02,10.58c3.37,8.88,15.94,8.88,19.31,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 594.86,
    y: 229.72,
    width: 39.78,
    height: 9.59,
    transform: "translate(1229.49 469.02) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M630.82,369.51h7.29c2.85,0,5.16,2.31,5.16,5.16v8.51h-17.6v-8.51c0-2.85,2.31-5.16,5.16-5.16Z",
    transform: "translate(1268.93 752.68) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M634.46,346.49c9.25,0,16.76-7.5,16.76-16.76v-47.51c0-9.25-7.5-16.76-16.76-16.76s-16.76,7.5-16.76,16.76v47.51c0,9.25,7.5,16.76,16.76,16.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M651.22,377.25v-47.51c0-9.25-7.5-16.76-16.76-16.76s-16.76,7.5-16.76,16.76v47.51s33.51,0,33.51,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 629.06,
    y: 217.56,
    width: 20.02,
    height: 61.57,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(1278.15 496.69) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 629.06,
    y: 259.08,
    width: 20.02,
    height: 61.57,
    rx: 8.66,
    ry: 8.66,
    transform: "translate(1278.15 579.73) rotate(180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-74",
    cx: 645.64,
    cy: 311.38,
    r: 16.58
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M604.66,380.14l4.02-10.58c3.63-9.57-3.44-19.81-13.67-19.81h0c-10.23,0-17.3,10.24-13.67,19.81l4.02,10.58c3.37,8.88,15.94,8.88,19.31,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M591.36,354.86h7.29c2.85,0,5.16,2.31,5.16,5.16v8.51h-17.6v-8.51c0-2.85,2.31-5.16,5.16-5.16Z",
    transform: "translate(1190.01 723.39) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M595.01,335.52c9.25,0,16.76-7.5,16.76-16.76v-47.51c0-9.25-7.5-16.76-16.76-16.76s-16.76,7.5-16.76,16.76v47.51c0,9.25,7.5,16.76,16.76,16.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M611.76,362.6v-47.51c0-9.25-7.5-16.76-16.76-16.76s-16.76,7.5-16.76,16.76v47.51s33.51,0,33.51,0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M614.14,251.06c.82-.82,2.15-.82,2.97,0s.82,2.15,0,2.97l-2.97,2.97-2.97-2.97c-.82-.82-.82-2.15,0-2.97s2.15-.82,2.97,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M625.77,251.06c.82-.82,2.15-.82,2.97,0s.82,2.15,0,2.97l-2.97,2.97-2.97-2.97c-.82-.82-.82-2.15,0-2.97s2.15-.82,2.97,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M602.51,251.06c.82-.82,2.15-.82,2.97,0s.82,2.15,0,2.97l-2.97,2.97-2.97-2.97c-.82-.82-.82-2.15,0-2.97s2.15-.82,2.97,0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M606.45,263.6h.72c2.54,0,4.6,2.06,4.6,4.6v13.71h-5.31v-18.3h0Z",
    transform: "translate(1218.21 545.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M574.61,65.1h74.3c8.75,0,15.85,7.1,15.85,15.85v42.81c0,21.52-17.47,38.99-38.99,38.99h-28.02c-21.52,0-38.99-17.47-38.99-38.99v-42.81c0-8.75,7.1-15.85,15.85-15.85Z",
    transform: "translate(1223.52 227.86) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M590.56,97.5h25.82c18.71,0,33.9,15.19,33.9,33.9v54.49c0,11.66-9.47,21.12-21.12,21.12h-51.38c-11.66,0-21.12-9.47-21.12-21.12v-54.49c0-18.71,15.19-33.9,33.9-33.9Z",
    transform: "translate(1206.93 304.52) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 603.54,
    y: 185.77,
    width: 22.42,
    height: 25.89,
    transform: "translate(1229.49 397.43) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M595,154.58l-8.48,23.96c-.73,2.05.79,4.2,2.97,4.2h3.77c2.35,0,4.25-1.9,4.25-4.25v-23.47c0-1.45-2.03-1.8-2.51-.43Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M564.11,160.21h22.6c4.67,0,7.39-5.26,4.7-9.08l-1.65-2.33c-7-9.91-21.7-9.91-28.7,0l-1.65,2.33c-2.69,3.81.03,9.08,4.7,9.08Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 561.65,
    y: 146.42,
    width: 16.54,
    height: 27.75,
    rx: 7.15,
    ry: 7.15,
    transform: "translate(1139.83 320.59) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 572.85,
    y: 143.47,
    width: 7.11,
    height: 12.96,
    rx: 3.07,
    ry: 3.07,
    transform: "translate(1152.81 299.89) rotate(-180)"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M591.92,152s-5.58-10.63-16.51-10.63c-11.92,0-16.51,10.63-16.51,10.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 560.78,
    y1: 141.05,
    x2: 564.51,
    y2: 145.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 566.49,
    y1: 137.59,
    x2: 568.86,
    y2: 142.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 556.22,
    y1: 145.34,
    x2: 560.47,
    y2: 148.81
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M630.62,160.21h-22.6c-4.67,0-7.39-5.26-4.7-9.08l1.65-2.33c7-9.91,21.7-9.91,28.7,0l1.65,2.33c2.69,3.81-.03,9.08-4.7,9.08Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 605.99,
    y: 146.42,
    width: 16.54,
    height: 27.75,
    rx: 7.15,
    ry: 7.15
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 617.37,
    y: 143.47,
    width: 7.11,
    height: 12.96,
    rx: 3.07,
    ry: 3.07
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M602.81,152s5.58-10.63,16.51-10.63c11.92,0,16.51,10.63,16.51,10.63"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 633.95,
    y1: 141.05,
    x2: 630.21,
    y2: 145.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 628.23,
    y1: 137.59,
    x2: 625.87,
    y2: 142.55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-4",
    x1: 638.51,
    y1: 145.34,
    x2: 634.26,
    y2: 148.81
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M555.89,153.84h2.82c7.24,0,13.12,5.88,13.12,13.12v4.72h-14.3c-3.67,0-6.66-2.98-6.66-6.66v-6.16c0-2.77,2.25-5.02,5.02-5.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M630.13,153.84h14.3v4.72c0,7.24-5.88,13.12-13.12,13.12h-2.82c-2.77,0-5.02-2.25-5.02-5.02v-6.16c0-3.67,2.98-6.66,6.66-6.66Z",
    transform: "translate(1267.9 325.51) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 637.16,
    cy: 168.78,
    r: 8.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M608.71,104.64h10.58c17.79,0,32.22,14.43,32.22,32.22v101.22"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-32",
    cx: 557.57,
    cy: 168.78,
    r: 8.92
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M596.77,191.87s1.98-4.35,8.08-6.98c6.07-2.62,10.89-.56,10.89-.56,0,0-1.75,4.74-8.26,7.37-4.65,1.88-10.71.17-10.71.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M587.31,104.64h-10.58c-17.79,0-32.22,14.43-32.22,32.22v101.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M618.2,181.38c-2.82,9.02-12.41,14.04-21.43,11.22"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-40",
    cx: 320.09,
    cy: 268.89,
    r: 17.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 302.1,
    y: 247.81,
    width: 19.42,
    height: 21.08,
    transform: "translate(623.63 516.7) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 297.27,
    y: 164.68,
    width: 29.08,
    height: 62.71,
    rx: 12.58,
    ry: 12.58,
    transform: "translate(623.63 392.08) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M301.69,198.23h20.24c2.44,0,4.42,1.98,4.42,4.42v35.12c0,6.95-5.64,12.58-12.58,12.58h-3.92c-6.95,0-12.58-5.64-12.58-12.58v-35.12c0-2.44,1.98-4.42,4.42-4.42Z",
    transform: "translate(623.63 448.6) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 288.22,
    y: 232.34,
    width: 31.27,
    height: 81.79,
    rx: 15.64,
    ry: 15.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M295.65,282.81h15.87c4.41,0,7.98,3.58,7.98,7.98v49.07c0,7.47-6.06,13.53-13.53,13.53h-4.21c-7.47,0-13.53-6.06-13.53-13.53v-49.63c0-4.1,3.33-7.42,7.42-7.42Z",
    transform: "translate(607.72 636.2) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M288.22,340.77h28.22c4.15,0,7.51,3.37,7.51,7.51v7.17c0,2.21-1.79,4.01-4.01,4.01h-27.73c-2.21,0-4.01-1.79-4.01-4.01v-14.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M292.14,353.39h37.1c5.36,0,9.71,4.35,9.71,9.71v2.1c0,2.08-1.69,3.77-3.77,3.77h-43.03c-2.16,0-3.92-1.76-3.92-3.92v-7.74c0-2.16,1.76-3.92,3.92-3.92Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 261.18,
    y: 247.8,
    width: 31.27,
    height: 81.79,
    rx: 15.64,
    ry: 15.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M268.61,298.27h15.87c4.41,0,7.98,3.58,7.98,7.98v49.07c0,7.47-6.06,13.53-13.53,13.53h-4.21c-7.47,0-13.53-6.06-13.53-13.53v-49.63c0-4.1,3.33-7.42,7.42-7.42Z",
    transform: "translate(553.64 667.12) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M261.18,356.23h28.46c4.02,0,7.28,3.26,7.28,7.28v7.41c0,2.21-1.79,4.01-4.01,4.01h-27.73c-2.21,0-4.01-1.79-4.01-4.01v-14.69h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M265.11,368.85h37.1c5.36,0,9.71,4.35,9.71,9.71v2.1c0,2.08-1.69,3.77-3.77,3.77h-43.03c-2.16,0-3.92-1.76-3.92-3.92v-7.74c0-2.16,1.76-3.92,3.92-3.92Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 292.46,
    y1: 258.3,
    x2: 292.46,
    y2: 356.23
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M262.89,171.79h53.87c10.03,0,18.17,8.14,18.17,18.17v72.97h-90.2v-72.97c0-10.03,8.14-18.17,18.17-18.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M311.65,171.84c0,7.57-6.14,13.7-13.7,13.7h-8.12s-8.12,0-8.12,0c-7.57,0-13.7-6.14-13.7-13.7h0s43.65,0,43.65,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M324.19,117.07l-60.27-1.57c-7.49,0-13.61-6.13-13.61-13.61v-32.5c0-11.83,9.68-21.52,21.52-21.52l44.46,1.57c11.83,0,21.52,9.68,21.52,21.52v32.5c0,7.49-6.13,13.61-13.61,13.61Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 269.94,
    y: 151.19,
    width: 35.15,
    height: 24.16
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M279.2,59.96h45.96c10.79,0,19.55,8.76,19.55,19.55v64.08c0,16.83-13.67,30.5-30.5,30.5h-24.07c-16.83,0-30.5-13.67-30.5-30.5v-64.08c0-10.79,8.76-19.55,19.55-19.55Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M356.46,146.56h-10.63c-6.18,0-11.18,5.01-11.18,11.18v13.08c0,6.15-4.99,11.14-11.14,11.14h-22.08c-6.15,0-11.14-4.99-11.14-11.14v-13.08c0-6.18-5.01-11.18-11.18-11.18h-22.02v37.71l31.43.15v7.02h47.83v-7.02h20.12v-37.85Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 322.74,
    y: 98.77,
    width: 22.59,
    height: 31.64,
    rx: 9.77,
    ry: 9.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 330.27,
    y: 106.49,
    width: 12.91,
    height: 21.66,
    rx: 5.58,
    ry: 5.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 329.28,
    y: 103.07,
    width: 7.06,
    height: 12.87,
    rx: 3.05,
    ry: 3.05
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M335.62,151.68c-3.4,7.09-10.65,11.98-19.05,11.98s-15.63-4.89-19.04-11.98h38.09Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M312.38,149.48l-18.25.93c-.69.04-1.28-.5-1.32-1.19-.03-.61.38-1.15.96-1.29l17.77-4.28c4.19-.82,5.1,5.42.84,5.83h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M323.43,143.65l17.77,4.28c.68.16,1.09.84.93,1.52-.14.6-.69.99-1.29.96l-18.25-.93c-4.25-.4-3.35-6.65.84-5.83h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M319.62,111.18c-.58-1.37-2.51-1.37-3.09,0-2.26,5.37-6.19,18.82-6.19,26.58,0,6.62,7.74,7.1,7.74,7.1,0,0,7.74-.48,7.74-7.1,0-7.76-3.93-21.21-6.19-26.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M341.49,122.33h4.83v8.96c0,3.58-2.91,6.49-6.49,6.49h-1.43c-1.48,0-2.68-1.2-2.68-2.68v-7.01c0-3.18,2.58-5.77,5.77-5.77Z",
    transform: "translate(682.04 260.1) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-40",
    cx: 260.26,
    cy: 118.2,
    r: 13
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 252.7,
    y: 125.02,
    width: 4.58,
    height: 10.15,
    rx: 1.98,
    ry: 1.98
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-40",
    cx: 259.56,
    cy: 297.94,
    r: 17.99
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 258.13,
    y: 276.86,
    width: 19.42,
    height: 21.08
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 253.29,
    y: 193.73,
    width: 29.08,
    height: 62.71,
    rx: 12.58,
    ry: 12.58
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M265.88,227.28h3.92c6.95,0,12.58,5.64,12.58,12.58v35.12c0,2.44-1.98,4.42-4.42,4.42h-20.24c-2.44,0-4.42-1.98-4.42-4.42v-35.12c0-6.95,5.64-12.58,12.58-12.58Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M268.07,67h11.11v45.78c0,4.96-4.02,8.98-8.98,8.98h-2.79c-4.96,0-8.98-4.02-8.98-8.98v-36.13c0-5.33,4.32-9.65,9.65-9.65Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 284.67,
    y: 98.77,
    width: 22.59,
    height: 31.64,
    rx: 9.77,
    ry: 9.77
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 292.2,
    y: 106.49,
    width: 12.91,
    height: 21.66,
    rx: 5.58,
    ry: 5.58
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 291.21,
    y: 103.07,
    width: 7.06,
    height: 12.87,
    rx: 3.05,
    ry: 3.05
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M352.23,52.18c0-6.47-3.82-12.04-9.33-14.6-1.73-7.04-8.06-12.27-15.64-12.27-.28,0-.55.03-.83.04-1.87-3.55-5.58-5.99-9.87-5.99-1.56,0-3.04.32-4.39.9-3.43-2.05-7.42-3.26-11.71-3.26-5.15,0-9.88,1.72-13.7,4.6-1.86-1.4-4.17-2.24-6.68-2.24-4.84,0-8.95,3.09-10.49,7.39-1.42-.43-2.93-.67-4.5-.67-8.16,0-14.84,6.26-15.53,14.24-4.96,2.27-8.4,7.26-8.4,13.07,0,4.74,2.3,8.93,5.84,11.55-.64,1.28-1.01,2.72-1.01,4.25,0,5.27,4.27,9.55,9.55,9.55,4.15,0,7.66-2.65,8.98-6.34,2.99,2.43,6.8,3.89,10.96,3.89,4.83,0,9.19-1.97,12.34-5.14,3.07,4.57,8.28,7.59,14.21,7.59s10.98-2.93,14.07-7.39c2.74,2.67,6.35,4.45,10.37,4.85,1.7,1.57,3.97,2.54,6.47,2.54,5.27,0,9.55-4.27,9.55-9.55,0-.1-.01-.2-.02-.3.59-.84,1.1-1.73,1.54-2.67,4.9-2.76,8.22-8.01,8.22-14.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M280.68,122.33h2.44c6.27,0,11.36,5.09,11.36,11.36v4.09h-12.39c-3.18,0-5.77-2.58-5.77-5.77v-5.34c0-2.4,1.95-4.34,4.34-4.34Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-87",
    cx: 314.66,
    cy: 77.51,
    r: 17.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-87",
    cx: 314.66,
    cy: 55.7,
    r: 22.84
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-87",
    cx: 290.58,
    cy: 74.76,
    r: 17.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-87",
    cx: 277.6,
    cy: 69.26,
    r: 14.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-87",
    cx: 347.56,
    cy: 69.26,
    r: 14.38
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-87",
    cx: 288.3,
    cy: 57.54,
    r: 15.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-87",
    cx: 332.9,
    cy: 74.76,
    r: 17.4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-87",
    cx: 334.85,
    cy: 57.54,
    r: 15.59
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-87",
    cx: 299.99,
    cy: 46.38,
    r: 11.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-87",
    cx: 324.21,
    cy: 46.38,
    r: 11.16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-87",
    cx: 348.84,
    cy: 85.06,
    r: 9.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-87",
    cx: 275.01,
    cy: 85.06,
    r: 9.55
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 199.24,
    y: 185.09,
    width: 18.4,
    height: 56.58,
    rx: 7.96,
    ry: 7.96,
    transform: "translate(506.71 216.88) rotate(135)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 231.83,
    y: 198.6,
    width: 18.4,
    height: 56.58,
    rx: 7.96,
    ry: 7.96,
    transform: "translate(467.92 -14.15) rotate(90)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 260.81,
    cy: 220.85,
    r: 15.23
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 177.13,
    y: 245.97,
    width: 23.54,
    height: 69.86,
    rx: 10.19,
    ry: 10.19,
    transform: "translate(377.8 561.8) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M177.13,292.32h23.54v59.68c0,5.62-4.56,10.19-10.19,10.19h-3.17c-5.62,0-10.19-4.56-10.19-10.19v-59.68h0Z",
    transform: "translate(377.8 654.51) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 177.13,
    y: 335.46,
    width: 23.54,
    height: 14.15,
    transform: "translate(377.8 685.07) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-46",
    d: "M181.74,348.25h36.05v13.94h-33.21c-4.11,0-7.45-3.34-7.45-7.45v-1.88c0-2.54,2.07-4.61,4.61-4.61Z",
    transform: "translate(394.92 710.43) rotate(180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M177.13,233.52h32.28v46.32h-17.9c-7.93,0-14.38-6.44-14.38-14.38v-31.94h0Z",
    transform: "translate(386.54 513.36) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 177.13,
    y: 269.99,
    width: 34.79,
    height: 9.85,
    transform: "translate(389.05 549.83) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 155.47,
    y: 222.13,
    width: 43.32,
    height: 22.78
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 155.47,
    y: 224.37,
    width: 43.32,
    height: 7.27
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M177.13,51.95h0c-27.9,0-52.28,18.82-59.34,45.81l-16.16,61.79c-4.41,16.88,8.32,33.37,25.76,33.37h35.59c49.75,0,86.06-47.03,73.48-95.16h0c-7.06-26.99-31.44-45.81-59.34-45.81Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M165.3,192.93h23.67c9.59,0,17.37,7.78,17.37,17.37v9.29c0,3.49-2.83,6.32-6.32,6.32h-45.77c-3.49,0-6.32-2.83-6.32-6.32v-9.29c0-9.59,7.78-17.37,17.37-17.37Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M160.08,191.39h34.09v1.64c0,5.81-4.71,10.52-10.52,10.52h-13.05c-5.81,0-10.52-4.71-10.52-10.52v-1.64h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M155.89,108.88h77.03v45.28c0,21.39-17.37,38.76-38.76,38.76h-23.97c-13.06,0-23.66-10.6-23.66-23.66v-51.02c0-5.17,4.2-9.37,9.37-9.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M174.66,90.23h30.11c15.53,0,28.14,12.61,28.14,28.14v41.4c0,18.07-14.67,32.74-32.74,32.74h-20.92c-18.07,0-32.74-14.67-32.74-32.74v-41.4c0-15.53,12.61-28.14,28.14-28.14Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 164.35,
    y: 177.02,
    width: 25.56,
    height: 18.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M179.89,81.08h23.2c20.26,0,36.72,16.45,36.72,36.72v5.71h-36.4c-12.98,0-23.51-10.53-23.51-23.51v-18.92h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M155.47,236.38h43.32v10.26c0,7.41-6.01,13.42-13.42,13.42h-16.47c-7.41,0-13.42-6.01-13.42-13.42v-10.26h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M205.37,184.07c-8.26,2.69-17.13-1.82-19.82-10.08"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M201.64,151.61l6.34,17.9c.54,1.53-.59,3.14-2.22,3.14h-2.82c-1.76,0-3.18-1.42-3.18-3.18v-17.54c0-1.09,1.51-1.35,1.88-.32Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 158.76,
    y: 236.38,
    width: 2.86,
    height: 6.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 165.53,
    y: 236.38,
    width: 2.86,
    height: 6.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 172.31,
    y: 236.38,
    width: 2.86,
    height: 6.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 179.09,
    y: 236.38,
    width: 2.86,
    height: 6.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 185.86,
    y: 236.38,
    width: 2.86,
    height: 6.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 192.64,
    y: 236.38,
    width: 2.86,
    height: 6.29
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 154.84,
    y: 257.97,
    width: 23.54,
    height: 69.86,
    rx: 10.19,
    ry: 10.19
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M165.03,304.33h3.17c5.62,0,10.19,4.56,10.19,10.19v59.68h-23.54v-59.68c0-5.62,4.56-10.19,10.19-10.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M159.23,242.67h26.2v46.32h-40.58v-31.94c0-7.93,6.44-14.38,14.38-14.38Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 142.34,
    y: 279.14,
    width: 46.56,
    height: 9.85
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 154.84,
    y: 347.47,
    width: 23.54,
    height: 14.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M159.45,360.25h36.05v13.94h-33.21c-4.11,0-7.45-3.34-7.45-7.45v-1.88c0-2.54,2.07-4.61,4.61-4.61Z",
    transform: "translate(350.35 734.44) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M190.6,247.07h5.34v10.29c0,2.55-2.07,4.62-4.62,4.62h-.72v-14.92h0Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-20",
    x1: 178.16,
    y1: 290.57,
    x2: 178.16,
    y2: 345.22
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 168.23,
    y: 130.54,
    width: 24.13,
    height: 33.8,
    rx: 10.44,
    ry: 10.44
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 176.12,
    y: 140.22,
    width: 13.41,
    height: 22.49,
    rx: 5.8,
    ry: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 175.1,
    y: 136.68,
    width: 7.33,
    height: 13.37,
    rx: 3.17,
    ry: 3.17
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M168.23,142.81v-.21c0-6.66,5.4-12.06,12.06-12.06h0c6.66,0,12.06,5.4,12.06,12.06v.21"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 164.2,
    y1: 138.63,
    x2: 168.48,
    y2: 140.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 165.83,
    y1: 134.05,
    x2: 169.83,
    y2: 136.18
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 207.48,
    y: 130.54,
    width: 24.13,
    height: 33.8,
    rx: 10.44,
    ry: 10.44
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-51"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 215.38,
    y: 140.22,
    width: 13.41,
    height: 22.49,
    rx: 5.8,
    ry: 5.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 214.35,
    y: 136.68,
    width: 7.33,
    height: 13.37,
    rx: 3.17,
    ry: 3.17
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M207.48,142.81v-.21c0-6.66,5.4-12.06,12.06-12.06h0c6.66,0,12.06,5.4,12.06,12.06v.21"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 235.81,
    y1: 138.63,
    x2: 231.53,
    y2: 140.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 234.18,
    y1: 134.05,
    x2: 230.17,
    y2: 136.18
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M166.24,156.21h2.29c5.87,0,10.64,4.77,10.64,10.64v3.82h-11.59c-2.98,0-5.4-2.42-5.4-5.4v-5c0-2.24,1.82-4.07,4.07-4.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M223.2,156.21h10.47v7.03c0,4.1-3.33,7.43-7.43,7.43h-1.98c-2.94,0-5.33-2.39-5.33-5.33v-4.85c0-2.36,1.92-4.28,4.28-4.28Z",
    transform: "translate(452.59 326.87) rotate(-180)"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-7",
    points: "185.43 279.14 185.43 264.99 190.6 264.99"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M307.16,174.88l-11.68,49.76-55.71,15.56c-4.38,1.22-8.46-2.7-7.42-7.12l9.37-39.93,65.44-18.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M302.07,178.75l-9.87,42.12-65.67,18.34,8.53-36.39c.83-3.53,3.51-6.33,7-7.3l60.01-16.76Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M260.85,211.11l-61.22,17.1,3.22-6.38c1.49-2.96,4.14-5.14,7.29-6.02l48.26-13.48,2.45,8.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M302.07,178.75l-9.49,40.59-2.58-3.2c-2.05-2.54-2.82-5.89-2.07-9.08l4.76-20.35c.83-3.53,3.51-6.33,7-7.3l2.39-.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M252.16,206.09l41.92,15.21-4.39-6.15c-1.8-2.52-4.32-4.45-7.22-5.54l-18.47-6.93c-3.4-1.26-7.21-.57-9.96,1.8l-1.88,1.62Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "186.53 230.1 237.87 240.43 296.8 227.2 253.53 210.57 186.53 230.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M310.79,175.79l-10.56,43.78c-.75,3.12-4.03,4.92-7.07,3.87l-43.33-15.56-64.24,18.65"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 159.4,
    y: 202.59,
    width: 18.4,
    height: 56.58,
    rx: 7.96,
    ry: 7.96,
    transform: "translate(-113.88 186.84) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 192.42,
    y: 216.28,
    width: 18.4,
    height: 56.58,
    rx: 7.96,
    ry: 7.96,
    transform: "translate(-42.95 446.19) rotate(-90)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M221.39,223.31c8.41,0,15.23,6.82,15.23,15.23s-6.82,15.23-15.23,15.23-15.23-6.82-15.23-15.23,6.82-15.23,15.23-15.23Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 89.33,
    y: 183.96,
    width: 20.13,
    height: 61.9,
    rx: 8.71,
    ry: 8.71,
    transform: "translate(198.78 429.81) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 89.33,
    y: 225.7,
    width: 20.13,
    height: 61.9,
    rx: 8.71,
    ry: 8.71,
    transform: "translate(198.78 513.29) rotate(-180)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 105.99,
    cy: 278.28,
    r: 16.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M82.92,172.26h32.33v28.66c0,7.72-6.27,13.99-13.99,13.99h-4.35c-7.72,0-13.99-6.27-13.99-13.99v-28.66h0Z",
    transform: "translate(198.16 387.16) rotate(-180)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M53.86,141.35h16.95v20.82c0,13.34-10.83,24.17-24.17,24.17h-15.39v-22.39c0-12.48,10.13-22.61,22.61-22.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M31.96,100.27h103.73v30.85c0,13.37-10.86,24.23-24.23,24.23h-55.27c-13.37,0-24.23-10.86-24.23-24.23v-30.85h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M68.75,327.82c-6.1,0-11.04-4.94-11.04-11.04v-54.02c0-6.1,4.94-11.04,11.04-11.04s11.04,4.94,11.04,11.04v54.02c0,6.1-4.94,11.04-11.04,11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M57.71,370.81v-54.02c0-6.1,4.94-11.04,11.04-11.04s11.04,4.94,11.04,11.04v54.02h-22.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M62.13,365.11h36.71v15.35h-32.26c-4.89,0-8.86-3.97-8.86-8.86v-2.07c0-2.44,1.98-4.42,4.42-4.42Z",
    transform: "translate(156.55 745.57) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M90.82,312.69c6.1,0,11.04-4.94,11.04-11.04v-54.02c0-6.1-4.94-11.04-11.04-11.04-6.1,0-11.04,4.94-11.04,11.04v54.02c0,6.1,4.94,11.04,11.04,11.04Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M101.85,355.68v-54.02c0-6.1-4.94-11.04-11.04-11.04-6.1,0-11.04,4.94-11.04,11.04v54.02s22.07,0,22.07,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M84.2,349.98h36.71v15.35h-32.26c-4.89,0-8.86-3.97-8.86-8.86v-2.07c0-2.44,1.98-4.42,4.42-4.42Z",
    transform: "translate(200.69 715.3) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M67.01,176.34h25.55c11.05,0,20.03,8.97,20.03,20.03v70.85H46.98v-70.85c0-11.05,8.97-20.03,20.03-20.03Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 125.24,
    cy: 115.27,
    r: 13.32
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 43.43,
    cy: 115.27,
    r: 13.32
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M62.31,37.16h43.06c16.74,0,30.34,13.59,30.34,30.34v33.37c0,5.24-4.26,9.5-9.5,9.5H41.48c-5.24,0-9.5-4.26-9.5-9.5v-33.37c0-16.74,13.59-30.34,30.34-30.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.26,55.41h45.18c11.13,0,20.16,9.03,20.16,20.16v65.33c0,18.28-14.84,33.12-33.12,33.12h-19.27c-18.28,0-33.12-14.84-33.12-33.12v-65.33c0-11.13,9.03-20.16,20.16-20.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M68.75,154.38h22.06v23.7c0,5.27-4.28,9.54-9.54,9.54h-2.97c-5.27,0-9.54-4.28-9.54-9.54v-23.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M110.35,143.13c-6.6,6.6-17.3,6.6-23.9,0"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M58.35,98.09h22.7c2.81,0,5.1,2.29,5.1,5.1v3.65h-32.9v-3.65c0-2.81,2.29-5.1,5.1-5.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M80.59,101.71h-21.79c-4.5,0-7.13,5.07-4.53,8.75l1.59,2.25c6.75,9.55,20.91,9.55,27.67,0l1.59-2.25c2.6-3.67-.03-8.75-4.53-8.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 66.89,
    y: 90.8,
    width: 15.94,
    height: 26.74,
    rx: 6.9,
    ry: 6.9,
    transform: "translate(149.72 208.34) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 64.72,
    y: 106.85,
    width: 6.85,
    height: 12.49,
    rx: 2.96,
    ry: 2.96,
    transform: "translate(136.3 226.19) rotate(180)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M103.6,98.09h22.7c2.81,0,5.1,2.29,5.1,5.1v3.65h-32.9v-3.65c0-2.81,2.29-5.1,5.1-5.1Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M125.84,101.71h-21.79c-4.5,0-7.13,5.07-4.53,8.75l1.59,2.25c6.75,9.55,20.91,9.55,27.67,0l1.59-2.25c2.6-3.67-.03-8.75-4.53-8.75Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 112.13,
    y: 90.8,
    width: 15.94,
    height: 26.74,
    rx: 6.9,
    ry: 6.9,
    transform: "translate(240.21 208.34) rotate(-180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 109.97,
    y: 106.85,
    width: 6.85,
    height: 12.49,
    rx: 2.96,
    ry: 2.96,
    transform: "translate(226.79 226.19) rotate(-180)"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M99.92,102.71c-.57-1.7-2.47-1.7-3.04,0-2.22,6.64-6.08,16.88-6.08,26.48,0,8.19,7.6,8.78,7.6,8.78,0,0,7.6-.59,7.6-8.78,0-9.6-3.86-19.84-6.08-26.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M125.24,159.98v8.79c0,8.48-6.87,15.35-15.35,15.35h-23.51c-8.48,0-15.35-6.87-15.35-15.35v-8.79c0-3.22,2.61-5.82,5.82-5.82h1.01c2.05,0,3.71,1.66,3.71,3.71v5.67c0,3.09,2.5,5.59,5.59,5.59h21.92c3.09,0,5.59-2.5,5.59-5.59v-5.67c0-2.05,1.66-3.71,3.71-3.71h1.01c3.22,0,5.82,2.61,5.82,5.82Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-37",
    points: "105.7 195.93 79.6 222.44 89.73 225.7 75.94 250.7 105.7 222.51 95.03 218.12 105.7 195.93"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M110.02,107.08h24.75c1.94,0,3.52,1.58,3.52,3.52v6.5c0,2.93-2.38,5.31-5.31,5.31h-21.17c-2.93,0-5.31-2.38-5.31-5.31v-6.5c0-1.94,1.58-3.52,3.52-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M61.88,107.08h24.75c1.94,0,3.52,1.58,3.52,3.52v6.5c0,2.93-2.38,5.31-5.31,5.31h-21.17c-2.93,0-5.31-2.38-5.31-5.31v-6.5c0-1.94,1.58-3.52,3.52-3.52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M90.15,115.07s2.55-4.01,8.18-4.01,8.18,4.01,8.18,4.01"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 138.29,
    y1: 112.46,
    x2: 142.37,
    y2: 112.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-14",
    x1: 54.44,
    y1: 112.46,
    x2: 58.37,
    y2: 112.46
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M102.39,159.27l-1.83,2.53c-.97,1.35-2.98,1.35-3.95,0l-1.83-2.53c-.98-1.36-.01-3.25,1.66-3.25h4.29c1.67,0,2.64,1.9,1.66,3.25Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-11",
    x1: 79.96,
    y1: 267.22,
    x2: 79.96,
    y2: 361.93
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M110.83,85.63h20.57c2.38,0,4.31,1.93,4.31,4.31v2.08c0,1.23-1,2.22-2.22,2.22h-24.74c-1.23,0-2.22-1-2.22-2.22v-2.08c0-2.38,1.93-4.31,4.31-4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M65.59,85.63h20.57c2.38,0,4.31,1.93,4.31,4.31v2.08c0,1.23-1,2.22-2.22,2.22h-24.74c-1.23,0-2.22-1-2.22-2.22v-2.08c0-2.38,1.93-4.31,4.31-4.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M97.91,54.58h21.81v3.96h-18.39c-1.89,0-3.43-1.54-3.43-3.43v-.53h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M60.67,54.58h38.23v3.96h-41.66v-.53c0-1.89,1.54-3.43,3.43-3.43Z",
    transform: "translate(156.15 113.12) rotate(-180)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.31,
    y: 204.97,
    width: 20.13,
    height: 61.9,
    rx: 8.71,
    ry: 8.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 43.31,
    y: 246.7,
    width: 20.13,
    height: 61.9,
    rx: 8.71,
    ry: 8.71
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 46.77,
    cy: 299.28,
    r: 16.66
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M51.51,193.26h4.35c7.72,0,13.99,6.27,13.99,13.99v28.66h-32.33v-28.66c0-7.72,6.27-13.99,13.99-13.99Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.855564276f639adb0d7628942da9e84f.svg";
export { ForwardRef as ReactComponent };